function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  // Get the html from the data attribute and insert the new fields on the container
  // "event" is the click event of the link created by the rails helper
  window.addVanillaNestedFields = function (element) {
    if (!element.classList.contains('vanilla-nested-add')) element = element.closest('.vanilla-nested-add');
    var data = element.dataset;
    var container = document.querySelector(data.containerSelector);
    var newHtml = data.html.replace(/_idx_placeholder_/g, Date.now()); // insert and store reference

    var inserted;

    switch (data.methodForInsert) {
      case 'append':
        container.insertAdjacentHTML('beforeend', newHtml);
        inserted = container.lastElementChild;
        break;

      case 'prepend':
        container.insertAdjacentHTML('afterbegin', newHtml);
        inserted = container.firstElementChild;
        break;
    } // add a class to show it was added dynamically


    inserted.classList.add('added-by-vanilla-nested');

    _dispatchEvent(container, 'vanilla-nested:fields-added', element, {
      added: inserted
    }); // dispatch an event if we reached the limit configured on the model


    if (data.limit) {
      var nestedElements = container.querySelectorAll('[name$="[_destroy]"][value="0"]').length;
      if (nestedElements >= data.limit) _dispatchEvent(container, 'vanilla-nested:fields-limit-reached', element);
    }
  }; // Removes the fields or hides them until the undo timer times out
  // "event" is the click event of the link created by the rails helper


  window.removeVanillaNestedFields = function (element) {
    if (!element.classList.contains('vanilla-nested-remove')) element = element.closest('.vanilla-nested-remove');
    var data = element.dataset;
    var wrapper = element.parentElement;
    var sel = data.fieldsWrapperSelector;
    if (sel) wrapper = element.closest(sel);

    if (data.undoTimeout) {
      hideFieldsWithUndo(wrapper, element);

      _dispatchEvent(wrapper, 'vanilla-nested:fields-hidden', element);
    } else {
      hideWrapper(wrapper);
      unhideFields(wrapper);

      _dispatchEvent(wrapper, 'vanilla-nested:fields-removed', element);
    }

    wrapper.querySelector('[name$="[_destroy]"]').value = '1';
  }; // Hides an element, mainly the wrapper of a group of fields
  // "wrapper" is the wrapper of the link to remove fields


  function hideWrapper(wrapper) {
    if (wrapper.classList.contains('added-by-vanilla-nested')) {
      wrapper.remove();
    } else {
      var destroyInput = wrapper.querySelector('[name$="[_destroy]"');
      wrapper.innerHTML = '';
      wrapper.insertAdjacentElement('afterbegin', destroyInput);
    }
  } // Unhides the children given a fields wrapper
  // "wrapper" is the wrapper of the link to remove fields


  function unhideFields(wrapper) {
    _toConsumableArray(wrapper.children).forEach(function (child) {
      if (child.dataset.hasAttributeStyle) {
        child.style.display = child.dataset.originalDisplay;
      } else {
        child.removeAttribute("style");
      }
    });
  } // Hides an element and adds an "undo" link to unhide it
  // "wrapper" is the wrapper to hide
  // "element" is the link to remove the wrapper


  function hideFieldsWithUndo(wrapper, element) {
    _toConsumableArray(wrapper.children).forEach(function (child) {
      // store original style for after undo
      if (child.getAttribute("style")) {
        child.dataset.hasAttributeStyle = true;
        child.dataset.originalDisplay = child.style.display;
      }

      child.style.display = 'none';
    }); // add the 'undo' link with it's callback


    var undoLink = _createUndoWithElementsData(element.dataset);

    wrapper.appendChild(undoLink);

    var _onUndoClicked = function _onUndoClicked(e) {
      e.preventDefault();
      clearTimeout(timer);
      unhideFields(wrapper);
      wrapper.querySelector('[name$="[_destroy]"]').value = '0';

      _dispatchEvent(wrapper, 'vanilla-nested:fields-hidden-undo', undoLink);

      undoLink.remove();
    };

    undoLink.addEventListener('click', _onUndoClicked); // start the timer

    var _onTimerCompleted = function _onTimerCompleted() {
      hideWrapper(wrapper);
      unhideFields(wrapper);

      _dispatchEvent(wrapper, 'vanilla-nested:fields-removed', undoLink);

      undoLink.remove();
    };

    var ms = element.dataset.undoTimeout;
    var timer = setTimeout(_onTimerCompleted, ms);
  }

  function _dispatchEvent(element, eventName, triggeredBy, details) {
    if (!details) details = {};
    details.triggeredBy = triggeredBy;
    var event = new CustomEvent(eventName, {
      bubbles: true,
      detail: details
    });
    element.dispatchEvent(event);
  }

  function _createUndoWithElementsData(data) {
    var _undo$classList;

    var undo = document.createElement('A');
    undo.classList.add('vanilla-nested-undo');
    var classes = data.undoLinkClasses;
    if (classes) (_undo$classList = undo.classList).add.apply(_undo$classList, _toConsumableArray(classes.split(' ')));
    undo.innerText = data.undoText;
    return undo;
  }

  function initVanillaNested() {
    document.addEventListener('click', function (ev) {
      var addVanillaNested = ev.target.classList.contains('vanilla-nested-add') || ev.target.closest('.vanilla-nested-add');

      if (addVanillaNested) {
        ev.preventDefault();
        addVanillaNestedFields(ev.target);
      }
    });
    document.addEventListener('click', function (ev) {
      var removeVanillaNested = ev.target.classList.contains('vanilla-nested-remove') || ev.target.closest('.vanilla-nested-remove');

      if (removeVanillaNested) {
        ev.preventDefault();
        removeVanillaNestedFields(ev.target);
      }
    });
  }

  var vanillaNestedInitialized = false;

  var initOnce = function initOnce() {
    if (!vanillaNestedInitialized) {
      vanillaNestedInitialized = true;
      initVanillaNested();
    }
  };

  if (["complete", "interactive"].includes(document.readyState)) {
    // if DOMContentLoaded was already fired
    initOnce();
  } else {
    // else wait for it
    document.addEventListener("DOMContentLoaded", function () {
      return initOnce();
    });
  }
})();